/**
 * Product gallery loop
 * Last product photo par aage swipe / drag / scroll karne par pehli photo,
 * aur pehli photo par peeche karne par last photo aa jaati hai.
 * Sirf product page ki main gallery (<media-gallery> ke andar wala slideshow) par lagta hai,
 * zoom popup aur doosre slideshows par nahi.
 */
(() => {
  if (window.__productGalleryLoop) return;
  window.__productGalleryLoop = true;

  const SWIPE_MIN = 40; // px: itna swipe/drag hone par loop
  const WHEEL_MIN = 60; // trackpad / wheel ka jama hua horizontal scroll
  const COOLDOWN = 700; // ms: ek loop ke baad turant doosra na ho

  let lastLoop = 0;

  /** @returns {any} main gallery slideshow, warna null */
  const getGallery = (target) => {
    if (!(target instanceof Element)) return null;
    const slideshow = target.closest('slideshow-component');
    if (!slideshow) return null;
    if (!slideshow.closest('media-gallery')) return null;
    if (slideshow.closest('zoom-dialog, dialog')) return null;
    // Thumbnails ya controls par swipe ko ignore karo
    if (target.closest('slideshow-controls, .slideshow-controls, [ref="thumbnails"]')) return null;
    return slideshow;
  };

  const slideCount = (el) => (el.slides ? el.slides.length : 0);

  const loop = (el, to) => {
    const count = slideCount(el);
    if (count < 2) return;
    const now = Date.now();
    if (now - lastLoop < COOLDOWN) return;
    lastLoop = now;

    const index = to === 'first' ? 0 : count - 1;
    // Drag / native scroll ka snap pura hone do, phir loop.
    // Theme ka slideshow "infinite" hai: next() last se pehli photo par aage ki taraf
    // slide karta hai, previous() pehli se last par peeche ki taraf.
    setTimeout(() => {
      if (el.infinite && to === 'first' && typeof el.next === 'function') el.next();
      else if (el.infinite && to === 'last' && typeof el.previous === 'function') el.previous();
      else if (typeof el.select === 'function') el.select(index);
    }, 60);
  };

  /* ---------- Mobile: touch swipe ---------- */
  let touch = null;

  document.addEventListener(
    'touchstart',
    (e) => {
      const el = getGallery(e.target);
      if (!el || e.touches.length !== 1) return (touch = null);
      const t = e.touches[0];
      touch = { el, x: t.clientX, y: t.clientY, atEnd: el.atEnd, atStart: el.atStart };
    },
    { passive: true }
  );

  document.addEventListener(
    'touchend',
    (e) => {
      if (!touch) return;
      const { el, x, y, atEnd, atStart } = touch;
      touch = null;
      const t = e.changedTouches[0];
      if (!t) return;
      const dx = t.clientX - x;
      const dy = t.clientY - y;
      if (Math.abs(dx) < SWIPE_MIN || Math.abs(dx) < Math.abs(dy) * 1.2) return;

      // Edge par scroll aage nahi badhta, isliye thoda ruk ke check karo ki abhi bhi edge par hain
      setTimeout(() => {
        if (dx < 0 && atEnd && el.atEnd) loop(el, 'first');
        else if (dx > 0 && atStart && el.atStart) loop(el, 'last');
      }, 80);
    },
    { passive: true }
  );

  /* ---------- Desktop: mouse drag ---------- */
  let drag = null;

  document.addEventListener(
    'pointerdown',
    (e) => {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      const el = getGallery(e.target);
      drag = el ? { el, x: e.clientX, atEnd: el.atEnd, atStart: el.atStart } : null;
    },
    true
  );

  window.addEventListener('pointerup', (e) => {
    if (!drag || e.pointerType !== 'mouse') return;
    const { el, x, atEnd, atStart } = drag;
    drag = null;
    const dx = e.clientX - x;
    if (Math.abs(dx) < SWIPE_MIN) return;

    setTimeout(() => {
      if (dx < 0 && atEnd && el.atEnd) loop(el, 'first');
      else if (dx > 0 && atStart && el.atStart) loop(el, 'last');
    }, 80);
  });

  /* ---------- Desktop: trackpad / shift + mouse wheel ---------- */
  let wheelSum = 0;
  let wheelTimer = null;

  document.addEventListener(
    'wheel',
    (e) => {
      const el = getGallery(e.target);
      if (!el) return;
      const dx = e.deltaX || (e.shiftKey ? e.deltaY : 0);
      if (!dx || Math.abs(dx) < Math.abs(e.deltaY) * (e.shiftKey ? 0 : 1)) return;

      const pushingPastEnd = dx > 0 && el.atEnd;
      const pushingPastStart = dx < 0 && el.atStart;
      if (!pushingPastEnd && !pushingPastStart) {
        wheelSum = 0;
        return;
      }

      wheelSum += dx;
      clearTimeout(wheelTimer);
      wheelTimer = setTimeout(() => (wheelSum = 0), 250);

      if (wheelSum > WHEEL_MIN && el.atEnd) {
        wheelSum = 0;
        loop(el, 'first');
      } else if (wheelSum < -WHEEL_MIN && el.atStart) {
        wheelSum = 0;
        loop(el, 'last');
      }
    },
    { passive: true }
  );
})();
